module.exports = __webpack_public_path__ + "img/CloudDownloadOutlined.49c95251.svg";